module.exports = __webpack_public_path__ + "img/product-tutorial-4-music.5a0e1493.svg";